export enum Languages {
  English = "en",
  French = "fr",
}
